import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { mapLanguageToPageProps } from 'interview/i18n'
import FetchWithSpinner from 'components/fetch-with-spinner'
import QuestionResponseDialogue from 'interview/components/question-response-dialogue'
import Layout from 'interview/components/layout'
import {
  completeVideo,
  fetchMessages,
  removeDraft,
  saveDraft,
} from 'interview/actions/message'
import { find } from 'lodash'
import { USE_FILE_UPLOAD } from 'features'
import { H3 } from 'components/styled/typography'
import { PageContent } from 'components/styled/page/page-content'
import { getCompanyAndInterviewInfoForAmplitude } from 'selectors'

const propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.shape({
    context: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
  }).isRequired,
  responses: PropTypes.arrayOf(PropTypes.shape({})),
  questions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  globalRecorder: PropTypes.string,
  position: PropTypes.shape({}),
}

const defaultProps = {
  responses: [],
  globalRecorder: '',
  position: undefined,
}

class Messages extends React.Component {
  /**
   * When video is changed dispatch changes to backend
   */
  onVideoChange(questionId) {
    const { dispatch, params, responses, globalRecorder } = this.props
    const videoResponse = find(responses, { questionId })
    dispatch(
      saveDraft({
        context: params.context,
        isMobile: USE_FILE_UPLOAD || globalRecorder === 'upload',
        uuid: params.token,
        response: videoResponse,
      })
    )
  }

  /**
   * When user submits single video
   */
  onVideoSubmit(questionId) {
    const { dispatch, params, responses } = this.props
    const videoResponse = find(responses, { questionId })
    dispatch(
      completeVideo({
        context: params.context,
        uuid: params.token,
        response: videoResponse,
      })
    )
  }

  /**
   * When user removes draft
   */
  onVideoRemove(questionId) {
    const { dispatch, params, responses } = this.props
    const videoResponse = find(responses, { questionId })
    dispatch(
      removeDraft({
        context: params.context,
        uuid: params.token,
        response: videoResponse,
      })
    )
  }

  render() {
    const { i18n, params, questions, responses, position } = this.props
    const answerable = questions.find(question => question.answerable)
    const className = answerable
      ? 'personal-questions-answerable'
      : 'personal-questions'
    const companyAndInterviewInfo =
      getCompanyAndInterviewInfoForAmplitude(position)
    const personInfo =
      params.context === 'candidate'
        ? { candidateUuid: params.token }
        : { applicationToken: params.token }
    return (
      <FetchWithSpinner action={() => fetchMessages(params)}>
        <Layout>
          <PageContent size="small" className={className}>
            <H3>{i18n.messages.title}</H3>
            <QuestionResponseDialogue
              maxWidth
              context="messages"
              questions={questions}
              responses={responses}
              uuid={params.token}
              type={params.context}
              useFileUpload={USE_FILE_UPLOAD}
              showResponses={!!answerable}
              onVideoSubmit={questionId => {
                this.onVideoSubmit(questionId)
              }}
              onVideoChange={questionId => {
                this.onVideoChange(questionId)
              }}
              onVideoRemove={questionId => {
                this.onVideoRemove(questionId)
              }}
              locationId="messagesPage"
              videoEventProps={{
                ...companyAndInterviewInfo,
                ...personInfo,
                context: params.context,
              }}
            />
          </PageContent>
        </Layout>
      </FetchWithSpinner>
    )
  }
}

Messages.propTypes = propTypes
Messages.defaultProps = defaultProps

export default connect(
  mapLanguageToPageProps(state => ({
    questions: state.messages.questions,
    responses: state.messages.videoResponses,
    globalRecorder: state.global.recorder,
    position: state.interview.jobOpening,
  }))
)(Messages)
